import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { AccountType } from "models/account_type";
import { ContaFinanceiro } from "models/conta_financeiro";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import { useState } from "react";
import InputMask from "react-input-mask";
interface IFormContaFinanceiro {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: ContaFinanceiro;
  save: () => void;
  onChangeSelectedConta: (item: string) => void;
  changeInput: (value: any, type: string) => void;
  textColor: string;
  brandStars: string;
  loading: boolean;
  tipoConta: AccountType[];
  selectedConta: AccountType;
  filiais: PessoaType[];
  onChangeFilial: (item: string) => void;
  selectedFilial: PessoaType
}

const FormContaFinanceiro = ({
  show,
  showModal,
  accountSelected,
  save,
  onChangeSelectedConta,
  brandStars,
  changeInput,
  loading,
  textColor,
  tipoConta,
  selectedConta,
  filiais,
  onChangeFilial,
  selectedFilial
}: IFormContaFinanceiro) => {
  const [mask, setMask] = useState("");

  const showInput = (selected: string) => {
    changeInput( "tipoPessoa", selected);

    if (selected === "2") {
      setMask("99.999.999/9999-99");
    } else {
      setMask("999.999.999-99");
    }
  };

  return (
    <Modal
      onClose={() => {
        showModal(false);
      }}
      size={"4xl"}
      isOpen={show}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <ModalHeader flexDirection={"row"}>Cadastro de Contas</ModalHeader>
          <ModalCloseButton />
          <SimpleGrid spacing={4}>
          <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Empresa Saída/Filial
              </FormLabel>

              <Select size="md"
              onChange={(e) => onChangeFilial(e.target.value)}
              defaultValue={accountSelected?.empresaSaiadaId}
              >
                <option value={"0"}>NENHUMA</option>
                {filiais?.map((item) => (
                  <option value={item.id}>{item.nome}</option>
                ))}
              </Select>


            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Categoria da Conta<Text color={brandStars}>*</Text>
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => onChangeSelectedConta(e.value)}
                placeholder="Buscar..."
                isDisabled={false}
                name={"cliente"}
                defaultValue={{
                  label: tipoConta?.find((f) => f.id === selectedConta?.id)
                    ?.descricao,
                  value: tipoConta?.find((f) => f.id === selectedConta?.id)?.id,
                }}
                options={tipoConta?.map((item) => {
                  return {
                    label: item?.descricao,
                    value: item?.id,
                  };
                })}
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Tipo de Conta
              </FormLabel>

              <Select
                size="md"
                onChange={(e) => changeInput("tipo", e.target.value,)}
                defaultValue={accountSelected?.tipo}
              >
                <option value={"0"}>SELECIONE O TIPO</option>
                <option value={"1"}>CORRENTE</option>
                <option value={"2"}>POUPANÇA</option>
                <option value={"3"}>CARTÃO DE CRÉDITO</option>
                <option value={"4"}>OUTRO</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Tipo de Pessoa
              </FormLabel>

              <Select
                size="md"
                onChange={(e) => {
                  showInput(e.target.value);
                }}
                defaultValue={accountSelected?.tipoPessoa}
              >
                <option value={"0"}>SELECIONE O TIPO DE PESSOA</option>
                <option value={"1"}>FÍSICA</option>
                <option value={"2"}>JÚRIDICA</option>
                <option value={"3"}>CARTÃO DE CRÉDITO</option>
                <option value={"4"}>OUTRO</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Descrição<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.descricao}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha a Descrição"
                onChange={(e) => changeInput("descricao", e.target.value)}
                fontWeight="500"
                size="lg"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Titular<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.titular}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o titular"
                onChange={(e) => changeInput("titular", e.target.value)}
                fontWeight="500"
                size="lg"
              />
            </FormControl>

            
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Documento<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.documento}
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder={
                  mask === "999.999.999-99"
                    ? "Preencha o CPF"
                    : "Preencha o CNPJ"
                }
                onChange={(e) => changeInput("documento", e.target.value)}
                fontWeight="500"
                size="md"
                as={InputMask}
                mask={mask}
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Banco<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.banco}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o código do banco"
                onChange={(e) => changeInput("banco", e.target.value)}
                fontWeight="500"
                size="lg"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Agência<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.agencia}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o código da Agência"
                onChange={(e) => changeInput("agencia", e.target.value)}
                fontWeight="500"
                size="lg"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Número da Conta/Cartão <Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.numero}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o numero da conta/cartão"
                onChange={(e) => changeInput("numero", e.target.value)}
                mb="16px"
                fontWeight="500"
                size="lg"
              />
            </FormControl>
          </SimpleGrid>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
          <Button
            onClick={() => {
              save();
            }}
            colorScheme="brand"
            isLoading={loading}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default FormContaFinanceiro;
